(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.image-slider-container');
    let currentIndex = 0;
    const sliderContainer = document.querySelector('.slider-images');
    const sliderElement = document.querySelector('.custom-slider');
    const prevButton = document.querySelector('.slider-nav.prev');
    const nextButton = document.querySelector('.slider-nav.next');
    
    // Get all slide elements (both <a> and <img> that are direct children)
    const slides = sliderContainer.children;
    const totalImages = slides.length;
    
    // Get autoplay settings from data attributes
    const autoplayEnabled = container.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(container.getAttribute('data-autoplay-speed')) || 3000;
    let autoplayInterval;
    let isHovering = false;

    // Function to move the slider to the next or previous image
    function moveToIndex(index) {
      if (index >= totalImages) {
        currentIndex = 0; // Loop back to the first image
      } else if (index < 0) {
        currentIndex = totalImages - 1; // Loop to the last image
      } else {
        currentIndex = index;
      }

      // Get the actual width of the slider container (visible area)
      const slideWidth = sliderElement.offsetWidth;
      
      // Calculate translation - each slide takes exactly the width of the container
      const translateValue = currentIndex * slideWidth;
      
      sliderContainer.style.transform = 'translateX(-' + translateValue + 'px)';
    }

    // Function to start autoplay
    function startAutoplay() {
      stopAutoplay(); // Clear any existing interval first
      if (autoplayEnabled && totalImages > 1 && !isHovering) {
        autoplayInterval = setInterval(function() {
          moveToIndex(currentIndex + 1);
        }, autoplaySpeed);
      }
    }

    // Function to stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Event listeners for the navigation buttons
    prevButton.addEventListener('click', function () {
      moveToIndex(currentIndex - 1);
      startAutoplay(); // Restart autoplay with fresh timer
    });

    nextButton.addEventListener('click', function () {
      moveToIndex(currentIndex + 1);
      startAutoplay(); // Restart autoplay with fresh timer
    });

    // Pause autoplay on hover
    sliderElement.addEventListener('mouseenter', function() {
      isHovering = true;
      stopAutoplay();
    });
    
    sliderElement.addEventListener('mouseleave', function() {
      isHovering = false;
      startAutoplay();
    });

    // Recalculate on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        // Recalculate position on resize
        moveToIndex(currentIndex);
      }, 250);
    });

    // Start autoplay on page load if enabled
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
